import React from 'react';
import { Icon } from './Icon';

export const ExclamationCircleIcon: Icon = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20.999" height="21" viewBox="0 0 20.999 21" {...props}>
      <path id="Info_Icon" data-name="Info Icon" d="M68.531,871a10.5,10.5,0,1,0-10.5-10.5A10.5,10.5,0,0,0,68.531,871Zm-1.683-16.68h3.264v7.661H66.847Zm1.632,9.193a1.762,1.762,0,1,1-1.762,1.762A1.762,1.762,0,0,1,68.48,863.512Z" transform="translate(-58.031 -849.999)" fill="#f2af00"/>
    </svg>
  );
};

export default ExclamationCircleIcon;